import { render } from "./SettingPriceIndex.vue?vue&type=template&id=d43f4834&scoped=true"
import script from "./SettingPriceIndex.vue?vue&type=script&lang=js"
export * from "./SettingPriceIndex.vue?vue&type=script&lang=js"

import "./SettingPriceIndex.vue?vue&type=style&index=0&id=d43f4834&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d43f4834"]])

export default __exports__